import { ParsedValue } from './yearMonthPickerTypes';

export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const MONTHS_SHORT = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export const parseValue = (value: string | null | undefined): ParsedValue => {
  if (!value) return { year: null, month: null };
  try {
    const date = new Date(value);
    return {
      year: date.getFullYear(),
      month: date.getMonth(),
    };
  } catch {
    return { year: null, month: null };
  }
};

export const getDisplayValue = (value: string | ParsedValue, mode: 'year' | 'month'): string => {
  const { year, month } = typeof value === 'string' ? parseValue(value) : value;

  if (!year) return '';

  if (mode === 'year') {
    return year.toString();
  } else {
    return month !== null ? `${MONTHS[month]} ${year}` : '';
  }
};

// Generate years for grid (3 rows x 4 columns = 12 years per page)
// Last page is always full (12 items)
export const getYearPages = (minYear: number, maxYear: number): number[][] => {
  const years: number[][] = [];
  const allYears: number[] = [];

  for (let year = minYear; year <= maxYear; year++) {
    allYears.push(year);
  }

  const totalYears = allYears.length;
  const pageSize = 12;
  const remainder = totalYears % pageSize;

  if (remainder === 0) {
    // Perfect division, split normally
    for (let i = 0; i < allYears.length; i += pageSize) {
      years.push(allYears.slice(i, i + pageSize));
    }
  } else {
    // Make the first page partial, keep the last page full
    const firstPageSize = remainder;
    years.push(allYears.slice(0, firstPageSize));

    // Add remaining full pages
    for (let i = firstPageSize; i < allYears.length; i += pageSize) {
      years.push(allYears.slice(i, i + pageSize));
    }
  }

  return years;
};
